import { Icon, getSvgIcon } from '@helpers/icons';
import { Device, until } from '@helpers/media';
import { withMotionMax } from '@hoc/withMotionMax';
import useMedia from '@hooks/useMedia';
import CarouselProvider from '@stories/Components/Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Connected from '@stories/Components/Misc/Carousels/Carousel/Connected/Connected';
import MotionTrack from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack';
import { MotionConfig } from 'framer-motion';
import Cookies from 'js-cookie';
import React from 'react';
import { AnnouncementBarStyles as S } from './AnnouncementBar.styles';
const AnnouncementBar = ({ items, overrideCookie, uniqueCookieName, }) => {
    const carouselReturnRef = React.useRef();
    const pauseRef = React.useRef(false);
    const isMobile = useMedia([`${until(Device.Tablet)}`], [true], false);
    React.useEffect(() => {
        if (overrideCookie) {
            // Delete cookie to make it accurate again when re-set from closing it //
            Cookies?.remove(uniqueCookieName);
        }
    }, [overrideCookie]);
    const handleClose = () => {
        const announcementBarController = document.querySelector('[data-has-announcement-bar="true"]');
        if (announcementBarController) {
            announcementBarController.setAttribute('data-has-announcement-bar', 'false');
            // Update the cookie to prevent the announcement bar from showing again for 30 days //
            Cookies.set(uniqueCookieName, new Date().valueOf().toString(), {
                expires: 15,
            });
        }
    };
    React.useEffect(() => {
        if (carouselReturnRef.current) {
            // Set auto-play up //
            const autoPlay = () => {
                if (!pauseRef.current && carouselReturnRef.current) {
                    carouselReturnRef.current.goToIndex((carouselReturnRef.current.activeIndex + 1) % items.length);
                }
            };
            const interval = setInterval(autoPlay, 10000);
            return () => clearInterval(interval);
        }
    }, [carouselReturnRef]);
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, { flush: "both" },
            React.createElement(MotionConfig, { transition: { duration: isMobile ? 1 : 2, ease: 'easeInOut' } },
                React.createElement(CarouselProvider, { count: items.length, paddingOffset: 0 },
                    React.createElement(Connected, null, (props) => {
                        carouselReturnRef.current = props;
                        return (React.createElement(React.Fragment, null,
                            items.length > 1 && (React.createElement(S.SingleCarouselControl, { "data-direction": "left", onClick: () => {
                                    carouselReturnRef.current?.goToIndex(carouselReturnRef.current.activeIndex === 0
                                        ? items.length - 1
                                        : carouselReturnRef.current.activeIndex - 1);
                                    pauseRef.current = true;
                                } }, getSvgIcon(Icon.Chevron))),
                            items.length > 1 && (React.createElement(S.ItemControls, null,
                                React.createElement(S.ArrowControl, { onClick: () => {
                                        carouselReturnRef.current?.goToIndex(carouselReturnRef.current.activeIndex === 0
                                            ? items.length - 1
                                            : carouselReturnRef.current.activeIndex - 1);
                                        pauseRef.current = true;
                                    } }, getSvgIcon(Icon.Chevron)),
                                React.createElement("span", null,
                                    carouselReturnRef.current.activeIndex + 1,
                                    " / ",
                                    items.length),
                                React.createElement(S.ArrowControl, { onClick: () => {
                                        carouselReturnRef.current?.goToIndex((carouselReturnRef.current.activeIndex + 1) % items.length);
                                        pauseRef.current = true;
                                    } }, getSvgIcon(Icon.Chevron)))),
                            React.createElement(S.ActiveItemSection, null,
                                React.createElement(MotionTrack, { enableCarousel: items.length > 1 }, items.map((item, i) => {
                                    const description = isMobile && item.description.length > 70
                                        ? `${item.description.substring(0, 80 -
                                            item.title.length -
                                            (item.cta.text ? item.cta.text.length : 0))}...`
                                        : item.description;
                                    return (React.createElement(S.CarouselItem, { key: `AnnouncementBar_${i}` },
                                        React.createElement(S.CarouselItemContent, { "data-in-view": carouselReturnRef.current?.activeIndex === i },
                                            React.createElement(S.CarouselIcon, null, getSvgIcon(item.icon)),
                                            React.createElement(S.CarouselTitle, null,
                                                React.createElement("strong", null, item.title),
                                                " | ",
                                                React.createElement("span", null, description),
                                                " -",
                                                ' ',
                                                React.createElement(S.CarouselCta, { "data-mobile": true },
                                                    React.createElement("a", { href: item.cta.url, target: item.cta.target },
                                                        item.cta.text,
                                                        " >"))),
                                            React.createElement(S.CarouselCta, { "data-desktop": true },
                                                React.createElement("a", { href: item.cta.url, target: item.cta.target },
                                                    item.cta.text,
                                                    " >")))));
                                }))),
                            items.length > 1 && (React.createElement(S.SingleCarouselControl, { "data-direction": "right", onClick: () => {
                                    carouselReturnRef.current?.goToIndex((carouselReturnRef.current.activeIndex + 1) % items.length);
                                    pauseRef.current = true;
                                } }, getSvgIcon(Icon.Chevron))),
                            React.createElement(S.CloseButton, { onClick: () => handleClose() }, getSvgIcon(Icon.CrossClose))));
                    }))))));
};
export default withMotionMax(AnnouncementBar);
